<template>
<div class="business-sign long-modal">
  <Modal width="800" v-model="show"  class="column-modal long-modal" :mask-closable="false"  :loading="loading">
      <div slot="header" class="modal-header">企业预定<span>{{rentType === 0? '整租' : '合租'}}</span></div>
      <div class="flex">
        <Tabs v-if="buildingList.length > 0" :value="buildingList[0].value" :animated="false" class="tab" @on-click="getRoomList">
          <Spin size="large" fix v-if="showSpin"></Spin>
          <TabPane v-for="(building,i) in buildingList" :key="building.value" :label="building.text" :name="building.value"   >
            <div class="houseList">
               <div class="stockNumber">
                 <ul v-if="canOrderList(allBuidings[building.value]).length > 0">
                   <house-number-pane v-if="item.isShowOrder===1" v-for="item in allBuidings[building.value]" :n="n" :key="item.stockFid" @check-change="handleClick" :dataId="item.stockFid" :stockNumber="item.stockNumber"></house-number-pane>
                 </ul>
                 <div style="padding-bottom:18px;" v-else>
                    暂无数据
                 </div>
               </div>
             </div>

          </TabPane>
        </Tabs>
        <div class="result">
          <div class="top">
            <h3>已选列表</h3>
            <span class="count">共计{{houseList.length}}</span>
          </div>
            <ul>
              <li v-for="(item,index) in houseList" :key="index" :dataId="item.stockFid"><span>{{item.stockNumber}}</span></li>
            </ul>
        </div>

      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="handleCancel">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading">
          <span v-if="!loading">保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>

    <create-business-book
      :projectFid="projectFid" :n="busbookKey" :roomsCount="bookroomsCount"
      :roomIds="roomIds" :createContractData="bookContractData"
      :bookstockNumber="bookstockNumber"
      @done="done"

    ></create-business-book>
    </Modal>

</div>
</template>

<script type="text/ecmascript-6">


  // 组件from  BusinessSignModal.vue

import HouseNumberPane from './HouseNumberPane';
import { getOutHouseList } from "api/outHouse"
  import {roomCanReservation} from "../../../../../api/book";
  import CreateBusinessBook from './CreateBusinessBook.vue'


  export default {
  created(){

  },
   props: {
    n: {
      type: Number,
      default: 0
    },
    closeKey:{
      type:Number,
      default:0
    },
    rentType: {
      type: Number,
      default:0
    },
    buildingList: {
      type: Array,
      default:() => {
        return []
      }
    },
    projectFid:{
      type: String,
      default:''
    },
  },
    components:{
      CreateBusinessBook,
      HouseNumberPane
    },
  computed:{

    allBuidings(){
      let buidings = {}
      this.buildingList.forEach( item => {
        buidings[item.value] = []
      })
      return buidings
    },
    params(){
      let params = {
        houseBuildingFid:this.buildingList[0].value,
        projectFid:this.projectFid,
        stockIsOrder:1,
        stockRentType:this.rentType
      }
      return params
    }

  },
  watch: {
		n() {
      this.loading = false
      this.houseList = []
      this.roomIds=''
      this.show = true;
      // console.log(this.getRoomsParam)
       this.initData(this.params)
    },
    closeKey(){
      this.show = false;
    }
  },
  data () {
    return {
      showSpin:true,
      show:false,
      loading:false,
      count:0,
      checked:false,
      houseList:[],
      roomIds:'',



      busbookKey:0,
      bookroomsCount:0,
      bookContractData:null,
      bookstockNumber:''


    }
  },
  methods:{
    done(){
      this.show=false
      this.$emit('update')
    },
    canOrderList(data){
      return data.filter(ele=>{
        return ele.stockIsOrder===1
      })

    },
    handleCancel(){
      this.show = false
    },
    handleClick(data){
      if(data.checked){
        this.houseList.push({stockFid:data.stockFid,stockNumber:data.stockNumber})
      } else{
        let i = this.houseList.findIndex((item)=> {
          return item.stockFid === data.stockFid
        })
        if (i > -1) {
          this.houseList.splice(i,1)
        }
      }
    },
    initData(params) {
      this.showSpin = true;
      return new Promise( (resolve,reject) => {
        getOutHouseList(params).then( res => {
          let list = []
          res.data.subFloorList.forEach( item => {
            list.push(...item.subStockList)
          })
         this.allBuidings[params.houseBuildingFid] = list
         this.showSpin = false
         resolve(this.allBuidings)
        })
      })
    },
    getRoomList(buildingId){

      if(this.allBuidings[buildingId].length>0) {
        return;
      }
      this.params.houseBuildingFid = buildingId

      this.initData(this.params).then( res => {

      })
    },
    save() {
      this.roomIds = ''
      let stockNumber=[]
      if(this.houseList.length === 0) {
        this.$Message.info('请选择房间')
        return
      }
      if(this.houseList.length>1){
        this.$Message.info('目前只支持单个房间的预定！')
        return


      }
      this.houseList.forEach( item => {
        this.roomIds += `${item.stockFid},`
        stockNumber.push(item.stockNumber)
      })
      let count = this.houseList.length
      this.roomIds = this.roomIds.slice(0,-1)
      let  params = {
        roomIds: this.roomIds,
        projectFid: this.projectFid
      }
      roomCanReservation(params).then( res => {
        if(!res.data){
          return
        }

        if(res.data.roomCanRent && !res.data.roomCanRent.canReservation) {
           this.$Message.error(res.data.roomCanRent.message||'error')
        } else {
          if(res.data.roomCanRent.canReservation && res.data.roomCanRent.message) {
            this.$Message.warning(res.data.roomCanRent.message)
          }
          if(Object.getOwnPropertyNames(res.data).length === 0) {
            this.$Message.error('查询房间是否可出租/可预订失败，请稍后再试')
          } else{

              this.bookroomsCount = count;
              // this.bookroomIds = data.roomIds;
              this.bookContractData = res.data;


              this.bookstockNumber=stockNumber.join(',')
              this.busbookKey++
            // this.$emit('save',{roomIds:this.roomIds,count,resData:res.data,stockNumber:stockNumber.join(',')})
          }
        }

      })

       //this.$emit('save',this.roomIds)
    }
  }

}
</script>

<style lang="css" scoped>
.item-width{
    width: 200px;
}
.area-width {
   width: 530px;
}
.flex {
  display: flex;
  border-bottom: 1px solid #DDDEE1;
}
.tab {
  flex: 1;
}
.result {
  width: 256px;
  border-left: 1px solid #DDDEE1;
}
.top{
    line-height: 36px;

    padding: 8px 16px 16px;
}
.top h3 {
  display: inline-block;
    font-size: 12px;
    font-weight: normal
}
.count {
  color: #CFA868;
  float:right;
}
.houseList {
  display: flex;

}
.floor {
  color:#474E5D;
  font-weight: bold;
  padding-left: 16px;
}
.stockNumber  {
  flex: 1;
  padding-right: 60px;
}

.result li {
  display: inline-block;
  text-align: center;
  width: calc(100% / 3);
  box-sizing: border-box;
  padding-left: 16px;
  padding-bottom: 16px;
}
.result li span {
  width:100%;
  display: inline-block;
  border: 1px solid #CFA868;
  border-radius: 2px;
  line-height: 28px;
}
</style>
